module.exports = __webpack_public_path__ + "rwanda.svg?9ae01851d1d6f415c98615604249ff0c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/rwanda.svg
// module id = 277
// module chunks = 10